import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";
import { orgSubscriptionDetailsSchema } from "~/modules/auth/network";

import { listUserOrganizationsResponseSchema, memberSchema, pendingMemberSchema } from "./schema";

export const orgDetailsQuery = createQueryRequestDefinition({
  queryKey: ["orgDetails"],
  host: "cap-srv",
  method: "GET",
  path: "/mirage-studio/org/details",
  responseSchema: z.object({
    orgProfile: z.object({
      id: z.string(),
      name: z.string(),
      thumbnailUrl: z.string(),
      members: memberSchema.array(),
      subscription: orgSubscriptionDetailsSchema.nullable(),
      pendingMembers: pendingMemberSchema.array(),
    }),
    userProfile: z.object({
      id: z.string(),
      name: z.string(),
      email: z.string(),
      permissions: z.array(z.string()),
    }),
  }),
});

export const listUserOrganizationsQuery = createQueryRequestDefinition({
  queryKey: ["user", "organizations"],
  host: "cap-srv",
  method: "GET",
  path: "/mirage-studio/org/list-organizations",
  responseSchema: listUserOrganizationsResponseSchema,
});
